import {Dispatch, useState, SyntheticEvent} from "react";
import {Alert, Snackbar, SnackbarOrigin} from "@mui/material";
import {AlertColor} from "@mui/material/Alert";


type SnackProp = {
    setOpen: Dispatch<boolean>,
    open: boolean,
    color?: AlertColor,
    message: string,
    duration?: number,
    anchor?: SnackbarOrigin,
}

export const Snack = ({setOpen, open, color = "success", message, duration = 6000, anchor = {horizontal: "right", vertical: "top"}}: SnackProp) => {

    const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
          return;
        }    
        setOpen(false);
    };

    return (
        <Snackbar open={open} autoHideDuration={duration} onClose={handleClose} anchorOrigin={anchor}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    )
}